'use strict';
moduleConfig.registerModule('eclipseApp.login', ['eclipseApp.core']);
